// extracted by mini-css-extract-plugin
export default {"container":"wogIx","headingGroup":"s1AFS"};